import * as React from 'react';
import { appInsights } from '../../AppInsights';
import {Title, SearchMain, Layout} from '../../components';
import styles from './Home.module.scss';

class Home extends React.Component<{}, {}> {

    componentDidMount() {
        localStorage.setItem('author', JSON.stringify([]));
        localStorage.setItem('title', JSON.stringify([]));
        localStorage.setItem('startDate', JSON.stringify('null'));
        localStorage.setItem('endDate', JSON.stringify('null'));
        localStorage.setItem('division', JSON.stringify([]));
        localStorage.setItem('documentType', JSON.stringify([]));
        localStorage.setItem("agency", JSON.stringify('non'));
        localStorage.setItem('securityGroup', JSON.stringify([]));
        window.history.pushState(null, 'Home', window.location.pathname);
    }

    public render() {
        appInsights.trackPageView({
            uri: window.location.href,
            name: 'Home'
        });
        return (
            <Layout>
                <div className={styles.home}>
                    <Title />
                    <div className={styles.searchHome} >
                        <SearchMain />
                    </div>
                </div>
            </Layout>
        )
    }

}

export default Home;
